module.exports = __webpack_public_path__ + "img/01宋雷.e39a5985.jpg";